export default "__VITE_ASSET__xYSyezDR__"